import { Outlet } from "react-router-dom";

import NavBar from "components/@common/NavBar/NavBar";
import { useAppSelector } from "store/redux/modules";
import { useAppDispatch } from "store/redux/modules";
import { setNavTab, checkFirstOpen } from "store/redux/modules/status";

export const MainLayout = () => {
  // =================== state  //
  const dispatch = useAppDispatch();
  const { navTab } = useAppSelector(({ account, user, status }) => {
    return {
      isAuthenticated: account.account?.account_id ? true : false,
      users: user.users,
      language: status.language,
      3: status.firstOpen,
      navTab: status.navTab,
      fcmToken: status.fcmToken,
    };
  });
  return (
    <div className="pb-navigation-height-safe-bottom pt-header-height">
      <Outlet />
      <NavBar
        navTab={navTab}
        setNavTab={(newNavTab: any) => dispatch(setNavTab(newNavTab))}
        checkFirstOpen={() => dispatch(checkFirstOpen(false))}
      />
    </div>
  );
};
